import PaidHolidayPatternAddForm from './PaidHolidayPatternAddForm';

export default PaidHolidayPatternAddForm;
